import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IEntitlementRepository } from '../../repositories/interfaces/iEntitlementRepository';
import InitiatedError from '../../entities/errors/InitiatedError';

export interface IQitafTvodVerifyOtpUseCase {
    execute(
        productId: string,
        qitafMsisdn: string,
        qitafRefId: string,
        otp: number,
        amount: number,
        uid: string,
        apiKey: string,
        token: string,
        identityToken: string
    ): Promise<string>;
}

export class QitafTvodVerifyOtpUseCase implements IQitafTvodVerifyOtpUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get qitafTvodVerifyOtpRepository(): IEntitlementRepository {
        return container.resolve<IEntitlementRepository>(DI.REPOSITORIES.IEntitlementRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        productId: string,
        qitafMsisdn: string,
        qitafRefId: string,
        otp: number,
        amount: number,
        uid: string,
        apiKey: string,
        token: string,
        identityToken: string
    ): Promise<string> {
        const response = await this.qitafTvodVerifyOtpRepository.qitafTvodVerifyOtp(
            productId,
            qitafMsisdn,
            qitafRefId,
            otp,
            amount,
            uid,
            apiKey,
            token,
            identityToken
        );
        if (response?.data) {
            return response.data;
        }
        throw new InitiatedError('REF_ID_MISSING', 'Reference ID missing');
    }
}
